import styled from 'styled-components';
import Grid from '@mui/material/Grid';

const GridExtra = styled(Grid)`
  ${({ margin }) => `margin: ${makeUnit(margin)} !important;`}
  ${({ padding }) => `padding: ${makeUnit(padding)};`}
`;
export default GridExtra;

const makeUnit = value => Array.isArray(value)
  ? value.map(makeUnitItem).join(' ')
  : makeUnitItem(value);
const makeUnitItem = value => typeof(value) === 'number'
  ? `${value}px`
  : value;
